export default __webpack_public_path__ + "static/aws-lambda-d2e2d4046db63e903f31baeda2c9817c.svg";